var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.63858C9.36868 1.44028 8.69684 1.33337 8.00004 1.33337C4.31814 1.33337 1.33337 4.31814 1.33337 8.00004C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00004C14.6667 6.85649 14.3788 5.78019 13.8715 4.83967M11.3334 3.83337H11.3367M7.00008 14.5922L7.00015 13.1233C7.00015 13.0438 7.02861 12.9668 7.08039 12.9064L8.73758 10.973C8.87377 10.8141 8.83157 10.5705 8.64988 10.4666L6.74573 9.37853C6.69399 9.34897 6.65113 9.30608 6.6216 9.25433L5.38035 7.07913C5.31575 6.96592 5.19109 6.90075 5.06126 6.91231L1.37616 7.24054M14 4.00004C14 5.4728 12.6667 6.66671 11.3334 8.00004C10 6.66671 8.66671 5.4728 8.66671 4.00004C8.66671 2.52728 9.86061 1.33337 11.3334 1.33337C12.8061 1.33337 14 2.52728 14 4.00004ZM11.5 3.83337C11.5 3.92542 11.4254 4.00004 11.3334 4.00004C11.2413 4.00004 11.1667 3.92542 11.1667 3.83337C11.1667 3.74133 11.2413 3.66671 11.3334 3.66671C11.4254 3.66671 11.5 3.74133 11.5 3.83337Z",
    stroke: "#5A5A5A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/World.364a4732a9fbe7f1959b408f1ae4bd99.svg";
export { ForwardRef as ReactComponent };